import { createFileRoute } from '@tanstack/react-router'
import { transferSearchSchema } from '../../../features/inventory/search'
import { StockTransfersListPage } from '../../../features/inventory/stock-transfers-list-page'

export const Route = createFileRoute('/_app/stock-transfers/')({
  validateSearch: transferSearchSchema,
  component: StockTransfersListPage,
})
